import { CloseRounded } from '@mui/icons-material';
import AllInclusiveOutlinedIcon from '@mui/icons-material/AllInclusiveOutlined';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import { AnimatePresence, motion } from 'framer-motion';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useAddToWishlistMutation } from '../redux/APIs/cartApi';
import { useLazyGetCurrentUserQuery } from '../redux/APIs/userApi';
import { setUser } from '../redux/Slices/userSlice';
import './ProductCards.css';
import SkeletonLoader from './layout/Loader/SkeletonLoader';

const ProductCards = ({ product, loading }) => {
  const  {user} = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isVisible, setIsVisible] = useState(false); 
  const [showQuickView, setShowQuickView] = useState(false); 
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const diff = product.markedPrice - product.price;
  const discount = (diff / product.markedPrice) * 100;
  const cardRef = useRef(null);
  const buttonRef = useRef(null);

  const [addToWishlist, {isLoading: isAdding}] = useAddToWishlistMutation();
  const [currentUser, {isLoading: fetchingCurrentUser}] = useLazyGetCurrentUserQuery();


  // const [loading, setLoading] = useState(true)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.intersectionRatio > 0);
      },
      {
        root: null,
        rootMargin: '0px -200px 0px 0px',
        threshold: 0,
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  const handleQuickViewClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Get the position of the button
    const rect = buttonRef.current.getBoundingClientRect();
    setPopupPosition({ x: rect.left, y: rect.top });
    setShowQuickView(true);
  };

  const wishlistHandler = async(e, productId) => {
    console.log('productId', productId)
    e.preventDefault();
    e.stopPropagation();
    const response = await addToWishlist(productId);
    console.log('response', response);
    if(response?.data){
      const res = await currentUser();
      console.log('res', res)
      if(res?.data){
        dispatch(setUser(res?.data?.user));
      }
    }
  }

  console.log('loading', loading)
  console.log('product.id', product)
  console.log('wishists', user?.wishlist)


  const isWishlisted = user?.wishlist?.includes(product?._id);

  console.log('isWishlisted', isWishlisted)


  return (
    <Fragment>
     <>
     {loading ? (
        <SkeletonLoader /> // Show skeleton loader while loading or no products
      ) : (
     <Link to={`/product/${product.slug}`} className='bg-white lg:h-[450px] lg:w-[300px] md:h-[350px] md:w-[233px] max-sm:h-[300px] max-sm:w-[calc((100vw-15px)/2)] rounded-xl shadow-lg no-underline text-black'>
        <div className='sm:h-[85%] max-sm:h-[80%] relative overflow-hidden' ref={cardRef}>
          <motion.img 
            src='https://www.taneira.com/dw/image/v2/BKMH_PRD/on/demandware.static/-/Sites-Taneira-product-catalog/default/dw2a475a1d/images/Taneira/Catalog/SABCIUHCC0101_1.jpg?sw=480&sh=728' 
            alt={product.name} 
            className='h-full w-full object-cover rounded-xl'
            whileHover={{ scale: 1.1 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
          />
          <div className='absolute h-12 w-fit bg-gradient-to-b from-pink-200 to-pink-500 top-0 left-3 border-dotted border-b-4 border-pink-600 flex flex-col items-center pt-2.5 px-1'>
            <span className='text-white font-bold text-xs'>5%</span>
            <span className='text-white font-bold text-[0.6rem]'>OFF</span>
          </div>

          <div className='absolute bottom-1 w-full flex justify-center gap-3'>
            <motion.div 
              ref={buttonRef} // Set ref to capture button position
              className='w-10 h-10 rounded-full bg-white shadow-md flex justify-center items-center relative overflow-hidden hover:text-pink-700 gap-1'
              onMouseEnter={() => setIsHovered1(true)}
              onMouseLeave={() => setIsHovered1(false)}
              initial={{ width: '2.5rem' }}
              whileHover={{ width: '8rem' }}
              onClick={handleQuickViewClick}
            >
              <AllInclusiveOutlinedIcon style={{ fontSize: 'large' }} />
              {isHovered1 && (
                <motion.button 
                  className='bottom-0 rounded-md p-1 flex justify-center items-center text-xs'
                  initial={{ opacity: 1 }}
                  animate={{ opacity: isHovered1 ? 1 : 0 }}
                  transition={{ duration: 0.2 }}
                >
                  QUICKVIEW
                </motion.button>
              )}
            </motion.div>
            <motion.div 
              className='w-10 h-10 rounded-full bg-white shadow-md flex justify-center items-center relative overflow-hidden hover:text-pink-700 gap-1'
              onMouseEnter={() => setIsHovered2(true)}
              onMouseLeave={() => setIsHovered2(false)}
              initial={{ width: '2.5rem' }}
              whileHover={{ width: '8rem' }}
              onClick={(e) => e.stopPropagation()}
            >
              {!isHovered2 && <div>
              {isWishlisted ? <FavoriteRoundedIcon style={{color: '#eb1679', fontSize: 'large'}}/> : <FavoriteBorderRoundedIcon style={{ fontSize: 'large' }} />}
              </div>}
              {isHovered2 && !isWishlisted && (
                <motion.button 
                  className='bottom-0 rounded-md p-1 flex justify-center items-center text-xs'
                  initial={{ opacity: 1 }}
                  animate={{ opacity: isHovered2 ? 1 : 0 }}
                  transition={{ duration: 0.4 }}

                  onClick={(e)=>wishlistHandler(e, product?._id)}
                >
                 <FavoriteBorderRoundedIcon style={{ fontSize: 'large',  marginRight: '4px' }} /> WISHLIST
                </motion.button>
              )}
              {isHovered2 && isWishlisted && (
                <motion.button 
                  className='bottom-0 rounded-md p-1 flex justify-center items-center text-xs'
                  initial={{ opacity: 1 }}
                  animate={{ opacity: isHovered2 ? 1 : 0 }}
                  transition={{ duration: 0.4 }}

                  // onClick={(e)=>wishlistHandler(e, product?._id)}
                >
                  <Link to='/wishlists' className='no-underline text-pink-600 hover:text-pink-700 w-full h-full flex'>
                  <FavoriteRoundedIcon style={{color: '#eb1679', fontSize: 'large', marginRight: '4px'}}/> WISHLISTED
                  </Link>
                </motion.button>
              )}
            </motion.div>
          </div>
        </div>

        <div className='sm:h-[15%] max-sm:h-[20%] px-3 py-1'>
          <p className='mb-0 capitalize'>{product.name}</p>
          <div className='flex gap-2 items-center'>
            <p className='font-semibold'>₹{product.price}</p>
            <p className='text-[0.8rem] line-through text-gray-500'>₹{product.markedPrice}</p>
          </div>
        </div>
      </Link>)}
     </>
      <AnimatePresence>
      {showQuickView && (
        <motion.div
        className="fixed inset-0 z-2 backdrop-blur-[0.5rem] bg-opacity-50 flex justify-center pt-10 overflow-auto hide-scrollbar"
        initial={{
          opacity: 0.5,
          scale: 0,
          x: popupPosition.x - window.innerWidth / 2.2, 
          y: popupPosition.y - window.innerHeight / 2.1,
        }}
        animate={{
          opacity: 1,
          scale: 1,
          x: 0,
          y: 0,
        }}
        exit={{
          opacity: 0.5,
          scale: 0,
          x: popupPosition.x - window.innerWidth / 2.2, 
          y: popupPosition.y - window.innerHeight / 2.1,
        }}
        transition={{ 
          type: 'spring',
          stiffness: 120,
          damping: 20,
          duration: 0.5, 
          ease: "easeInOut" }}
      >
        <div className="lg:relative absolute bottom-[35px] max-md:w-[90dvw] max-sm:w-[100dvw] max-sm:h-[80dvh] w-[900px] sm:h-[550px] h-[450px] flex gap-2 bg-white shadow-lg lg:mt-24 mb-0 max-sm:mt-[20px] rounded-t-[20px] p-2 overflow-hidden">
          <div className="lg:absolute max-md:hidden inset-0 rounded-[20px] p-[2px] bg-gradient-to-r from-pink-200 via-violet-200 to-teal-100 animate-spin-border"></div>
          <div className="relative w-full h-full lg:flex lg:gap-2 bg-white rounded-[15px] lg:p-3">
            <button
              className="absolute -top-0 right-0 max-sm:-top-2 max-sm:-right-2 max-sm:w-9 max-sm:h-9 w-10 h-10 bg-white rounded-full flex items-center justify-center"
              onClick={() => setShowQuickView(false)}
            >
              <CloseRounded style={{ fontSize: '1.2rem' }} />
            </button>
            <div className="md:h-full h-[65%] md:w-[45%] w-full">
              <img
                src="https://www.taneira.com/dw/image/v2/BKMH_PRD/on/demandware.static/-/Sites-Taneira-product-catalog/default/dw2a475a1d/images/Taneira/Catalog/SABCIUHCC0101_1.jpg?sw=480&sh=728"
                className="w-full h-full rounded-[12px] lg:object-cover object-top"
              />
            </div>
            <div className="flex-1 p-6">
              <p className="capitalize text-[1.2rem] font-semibold">{product.name}</p>
              <div className="flex gap-2 items-center">
                <p className="font-semibold">₹{product.price}</p>
                <p className="text-[0.8rem] line-through text-gray-500">₹{product.markedPrice}</p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
      
      )}
      </AnimatePresence>
    </Fragment>
  );
};

export default ProductCards;
